import React, { FC, useEffect } from "react";

import { useSubscriptionProviderContext } from "../../../../reportng/shared";
import { SubscriptionsSettings } from "../../../../reportng/SubscriptionsSettings";

import { ISubscriptionsSettingsSlideProps } from "./SubscriptionsSettingsSlide.types";

export const SubscriptionsSettingsSlide: FC<ISubscriptionsSettingsSlideProps> = (props) => {
  const { value, onChange, setApplyPayloadFunction } = props;
  const {
    state: { currentPayload },
    actions: { applyPayload },
  } = useSubscriptionProviderContext();

  useEffect(() => {
    if (currentPayload) {
      onChange(currentPayload);
    }
  }, [currentPayload, onChange]);

  useEffect(() => {
    if (applyPayload) {
      setApplyPayloadFunction((payload) => {
        if ("reportDefinition" in payload) {
          applyPayload(payload);
        }
      });
    }
  }, [applyPayload, setApplyPayloadFunction]);

  return <SubscriptionsSettings reportId={value.reportDefinition.id} />;
};
